import React from 'react';
import { Box, Container, useMediaQuery, CssBaseline, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../styles/theme';
import GoogleSignInButton from '../components/GoogleSignInButton';
import { GoogleAuthService } from '../services/GoogleAuthService';
import { router } from '@inertiajs/react';
import RenterBrandingSection from '../components/RenterBrandingSection';
import logo from '../assets/rounded_logo.svg';

const RenterLoginPage: React.FC = () => {
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          backgroundColor: '#FFFA66',
          minHeight: '100vh',
          width: '100vw',
          margin: 0,
          padding: isMobile ? 4 : 3,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: isMobile ? 'flex-start' : 'center',
          boxSizing: 'border-box',
          overflowX: 'hidden',
          position: 'relative'
        }}
      >
        {/* Logo in Top Left */}
        <Box
          component="img"
          src={logo}
          alt="Heyy Property Logo"
          sx={{
            position: 'absolute',
            top: isMobile ? 16 : 24,
            left: isMobile ? 16 : 24,
            width: isMobile ? '80px' : '120px',
            height: 'auto',
            zIndex: 1
          }}
        />
        <Container
          maxWidth={false}
          disableGutters={true}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobile ? 'flex-start' : 'center',
            justifyContent: 'center',
            textAlign: isMobile ? 'left' : 'center',
            width: '100%',
            maxWidth: isMobile ? '100%' : '600px',
          }}
        >
          <RenterBrandingSection animatedTaglines={false}>
            <GoogleSignInButton
              googleCallback={(response) =>
                GoogleAuthService.handleGoogleResponseForRenter(response, () => router.visit('home'))}
            />
          </RenterBrandingSection>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default RenterLoginPage;
